import { render, staticRenderFns } from "./ComponentesLista.vue?vue&type=template&id=0cae63ad&"
import script from "./ComponentesLista.vue?vue&type=script&lang=js&"
export * from "./ComponentesLista.vue?vue&type=script&lang=js&"
import style0 from "./ComponentesLista.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports